import styled from 'styled-components';

const Name = styled.span`
  ${({ theme }) => theme.fontFamily.secondaryFont.smallBold};
  color: ${props => props.theme.colors.textPrimary};
  overflow: hidden;
  line-height: 18px;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
`;

export default Name;
